import { useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { Alert } from "../components/Alert";
import { LanguageSwitcher, useI18n } from "../i18n/I18n";

/**
 * Shown instead of the app whenever there is no session.
 *
 * It is a button and not an automatic redirect: landing on an unexpected
 * Google consent screen is disorienting, and an expired session arriving here
 * mid-task should say so before throwing the browser somewhere else.
 */
export function SignInPage({
  returnTo = "/",
  message,
}: {
  returnTo?: string;
  message?: string;
}) {
  const auth = useAuth();
  const { t } = useI18n();
  const [starting, setStarting] = useState(false);

  return (
    <div className="app-signin">
      <div className="ds-card app-signin-card">
        <span className="ds-logo" />
        <h1 className="ds-text --xlarge">{t("app.title")}</h1>
        <p className="ds-text --muted">{t("auth.prompt")}</p>

        {message !== undefined && <Alert tone="failed">{message}</Alert>}

        <button
          type="button"
          className={`ds-button --primary --icon-signin${starting ? " --loading" : ""}`}
          disabled={starting}
          // SDS hides the label of a loading button; keep its name.
          aria-label={starting ? t("auth.redirecting") : undefined}
          onClick={() => {
            setStarting(true);
            auth.signIn(returnTo);
          }}
        >
          <span>{starting ? t("auth.redirecting") : t("auth.signIn")}</span>
        </button>

        <p className="ds-text --small --muted">{t("auth.purpose")}</p>

        {/* No header here, so the switch the shell carries sits on the card. */}
        <LanguageSwitcher />
      </div>
    </div>
  );
}
